<template>
  <div>
    <!-- MAIN ONBOARDING CARD -->
    <div v-if="!showFormA && !showFormK && !showFormRisk">
      <validation-observer ref="buyerRegisterValidation" name="RegisterBuyer">
        <b-card>
          <h3>{{ $t("add_buyer_details") }}</h3>

          <b-row class="mb-2 mt-2">
            <b-col cols="4">
              <b-card
                  tag="article"
                  class="investor-card text-center h-100"
                  :class="{'selected-card': selectedInvestorType === 'individual'}"
                  @click="selectInvestor('individual')"
              >
                <div class="icon-circle mb-3">
                  <feather-icon icon="UserIcon" size="25"/>
                </div>

                <h5 class="card-title">{{ $t("individual_investor") }}</h5>

                <p class="card-text">
                  {{ $t("individual_investor_desc_1") }}
                  <br>
                  {{ $t("individual_investor_desc_2") }}
                </p>

                <b-button
                    size="md"
                    class="mt-3"
                    :variant="selectedInvestorType === 'individual' ? 'primary' : 'outline-secondary'"
                >
                  {{ $t("please_select") }}
                </b-button>
              </b-card>
            </b-col>

            <b-col cols="4">
              <b-card
                  tag="article"
                  class="investor-card text-center h-100"
                  :class="{'selected-card': selectedInvestorType === 'professional'}"
                  @click="selectInvestor('professional')"
              >
                <div class="icon-circle mb-3">
                  <feather-icon icon="BriefcaseIcon" size="25"></feather-icon>
                </div>

                <h5 class="card-title">{{ $t("professional_investor") }}</h5>

                <p class="card-text">
                  {{ $t("professional_investor_desc_1")}}
                  <br>
                  {{ $t("professional_investor_desc_2")}}
                </p>

                <b-button
                    size="md"
                    class="mt-3"
                    :variant="selectedInvestorType === 'professional' ? 'primary' : 'outline-secondary'"
                >
                  {{ $t("please_select") }}
                </b-button>
              </b-card>
            </b-col>

            <b-col cols="4">
              <b-card
                  tag="article"
                  class="investor-card text-center h-100"
                  :class="{'selected-card': selectedInvestorType === 'institutional'}"
                  @click="selectInvestor('institutional')"
              >
                <div class="icon-circle mb-3">
                  <feather-icon icon="LayersIcon" size="25"/>
                </div>

                <h5 class="card-title">{{ $t("institutional_investor") }}</h5>

                <p class="card-text">
                  {{ $t("institutional_investor_desc_1") }}
                  <br>
                  {{ $t("institutional_investor_desc_2") }}
                </p>

                <b-button
                    size="md"
                    class="mt-3"
                    :variant="selectedInvestorType === 'institutional' ? 'primary' : 'outline-secondary'"
                >
                  {{ $t("please_select") }}
                </b-button>
              </b-card>
            </b-col>
          </b-row>

          <b-row class="p-1 d-flex align-center" v-if="selectedInvestorType !== null">
            <span class="mr-2" style="font-size:16px">
              {{ $t('are_you_sure_continue') }}
              <strong v-if="selectedInvestorType === 'individual'">
                {{ $t("individual_investor") }}
              </strong>
              <strong v-else-if="selectedInvestorType === 'professional'">
                {{ $t("professional_investor") }}
              </strong>
              <strong v-else-if="selectedInvestorType === 'institutional'">
                {{ $t("institutional_investor") }}
              </strong>
              ?
            </span>

            <b-button variant="primary" size="md" style="max-width: 150px" @click="completeIdentification">{{ $t('continue') }}</b-button>
          </b-row>

          <b-card v-if="choiceConfirmed" class="mt-2">
            <span>
              <hr/>
              <div id="sumsub-websdk-container"></div>
            </span>

            <b-col v-if="showLoader" cols="12" xl="6" md="6" lg="6">
              <img src="/new-loader.svg" alt="loading..." />
            </b-col>

            <b-col cols="12" class="justify-center text-center mt-2">
              <b-button @click="checkStatus" variant="outline-primary" class="mb-2">
                {{ $t('check_status') }}
              </b-button>
            </b-col>
          </b-card>
        </b-card>
      </validation-observer>
    </div>

    <!-- FORM A / FORM K (existing components) -->
    <div v-else-if="showFormA">
      <skribble-form-a></skribble-form-a>
    </div>

    <div v-else-if="showFormK">
      <skribble-form-k></skribble-form-k>
    </div>

    <!-- RISK ACKNOWLEDGEMENT / QES SIGNING -->
    <div v-if="showFormRisk">
      <b-card>
        <skribble-form-risk></skribble-form-risk>
      </b-card>
    </div>
  </div>

</template>

<script>
 import snsWebSdk from '@sumsub/websdk';
import { ValidationObserver } from 'vee-validate';
import ToastificationContent from '@core/components/toastification/ToastificationContent';
import SkribbleFormA from     '@/components/skribble/SkribbleFormA.vue';
import SkribbleFormK from     '@/components/skribble/SkribbleFormK.vue';
import SkribbleFormRisk from  '@/components/skribble/SkribbleFormRisk.vue';

import {
  BButton,
  BCard,
  BCol,
  BFormCheckbox,
  BRow,
} from 'bootstrap-vue';

export default {
  name: 'AddBuyer',
  components: {
    SkribbleFormA,
    SkribbleFormK,
    SkribbleFormRisk,
    BCard,
    BRow,
    BCol,
    BButton,
    BFormCheckbox,
    ValidationObserver,
  },
  data() {
    return {
      selectedInvestorType: null, // 'individual' | 'professional' | 'institutional'
      showModal: true,
      choiceConfirmed: false,
      showLoader: false,
      sumsubToken: null,
      sumsubUserId: null,
      levelName: null,
      sumsub_id: null,
      verified_at: '',
      mtanValue: '',
      showFormA: false,
      showFormK: false,
      showFormRisk: false,
      currentLocale: this.$i18n?.locale || 'en',
    };
  },

  created() {
    this.getUserInfo();
    this.checkForForm();
  },
  methods: {
    selectInvestor(type) {
      this.selectedInvestorType = type;
    },

    completeIdentification() {
      this.choiceConfirmed = true;
      this.showLoader = true;

      // map to sumsub level names
      if (this.selectedInvestorType === 'individual') {
        this.levelName = 'individual-investors';
      } else if (this.selectedInvestorType === 'professional') {
        this.levelName = 'professional-investors';
      } else if (this.selectedInvestorType === 'institutional') {
        this.levelName = 'institutional-investor/buyer';
      }

      this.$http.post(`/buyer/getSumsubClientId`, { role: this.levelName }).then((res) => {
        if (res.data && res.data.value) {
          this.sumsubUserId = res.data.value.clientId;
          this.requestSumsubToken();
        } else {
          this.showLoader = false;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('failed_to_get_sumsub_client'),
              icon: 'ErrorIcon',
              variant: 'error',
            },
          });
        }
      }).catch((err) => {
        console.error(err);
        this.showLoader = false;
      });
    },

    requestSumsubToken() {
      this.$http.post(`/sumsub/token?user_id=${this.$store.state.auth.user.id}&sumsub_id=${this.sumsubUserId}&level=${this.levelName}`).then((res) => {
        if (res.data) {
          this.sumsubToken = res.data.token;
          this.launchWebSdk();
        } else {
          this.showLoader = false;
        }
      }).catch((err) => {
        console.error(err);
        this.showLoader = false;
      });
    },

    launchWebSdk() {
      const accessToken = this.sumsubToken;
      const applicantEmail = this.$store.state.auth.user.email;
      const applicantPhone = this.$store.state.auth.user.tel;

      let snsWebSdkInstance = snsWebSdk.init(
          accessToken,
          () => this.getNewAccessToken()
      )
          .withConf({
            lang: this.currentLocale.startsWith('de') ? 'de' : 'en',
            email: applicantEmail,
            phone: applicantPhone,
          })
          .withOptions({ addViewportTag: false, adaptIframeHeight: true })
          .on('idCheck.onStepCompleted', (payload) => {
            console.log('onStepCompleted', payload);
          })
          .on('idCheck.onError', (error) => {
            console.log('onError', error);
          })
          .build();

      snsWebSdkInstance.launch('#sumsub-websdk-container');
      this.showLoader = false;
    },

    getNewAccessToken() {
      return this.$http.post(`/sumsub/token?user_id=${this.$store.state.auth.user.id}&sumsub_id=${this.sumsubUserId}&level=${this.levelName}`)
        .then((res) => {
          if (res.data) {
            this.sumsubToken = res.data.token;
            return this.sumsubToken;
          }
          return Promise.reject('no-token');
        });
    },

    getUserInfo() {
      this.$http.post(`/company/show/${this.$store.state.auth.user.company_id}`).then((res) => {
        if (res && res.data.value && res.data.value.main_contact) {
          const mc = res.data.value.main_contact;
          if (mc.sumsub_id != null) {
            this.sumsub_id = mc.sumsub_id;
            this.verified_at = mc.verified_at;
            this.mtanValue = mc.mTan;
          }
          if (!mc.status) {
            this.checkStatus();
          }
        }
      }).catch((err) => console.error(err));
    },

    checkForForm() {
      this.$http.post(`/company/tasks/check-for-form/`).then((res) => {
        if (res.data.value) {
          const result = res.data.value;
          const show = result.show_form;
          if (show) {
            if (result.form === 'formA') {
              this.showFormA = true;
            } else if (result.form === 'formK') {
              this.showFormK = true;
            } else if (result.form === 'formRisk') {
              this.showFormRisk = true;
            }
          }
        }
      }).catch((err) => console.error(err));
    },

    checkStatus() {
      this.$http.post(`/buyer/getSumsubClientId/status`).then((res) => {
        if (res.data.value && res.data.value.status && res.data.value.status.review && res.data.value.status.review.reviewStatus) {
          if (res.data.value.status.review.reviewStatus === 'completed') {
            this.checkForForm();
          }
        }
      }).catch((err) => console.error(err));
    },
  },
};
</script>

<style scoped>

.icon-circle:before {
  content: "";
}

.investor-card {
  cursor: pointer;
  border: 1px solid #e0e0e0;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.investor-card:hover {
  box-shadow: 0 8px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.investor-card.selected-card {
  border-color: #182c25;
  box-shadow: 0 4px 10px rgba(92, 184, 92, 0.3);
}

.icon-circle {
  width: 60px;
  height: 60px;
  background-color: #9fb79f;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #182c25;
  margin-left: auto;
  margin-right: auto;
}

.card-text {
  min-height: 70px;
}
</style>
